export default defineNuxtPlugin(() => {
  const route = useRoute();

  // Query params you want to prevent from being indexed
  const blockedParams = [
    'action',
    'availability',
    'barrel_length',
    'brand',
    'caliber',
    'capacity',
    'category',
    'char',
    'condition',
    'finish',
    'firearms',
    'hand',
    'page',
    'price_range',
    'q',
    'rebate',
    'sale',
    'sort',
  ];

  // Check if any blocked param exists in the current route
  const hasBlockedParam = Object.keys(route.query).some(key => blockedParams.includes(key));

  if (hasBlockedParam) {
    useRobotsRule({
      noindex: true,
      nofollow: true,
    });
  }
});
